import { Button } from 'antd';
import styled from 'styled-components';
import { red } from '~src/styles/colors';

export const StyledIconButton = styled(Button)<{ $iconType: 'normal' | 'danger' }>`
  padding: 8px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: unset !important;
  width: unset !important;

  svg {
    color: #838896;
  }

  &:hover {
    background-color: transparent;
  }

  &:hover svg {
    color: ${({ $iconType }) => ($iconType === 'normal' ? '#4e546b' : red.a10)};
  }
`;
